export const linkTop = [
    {
        // eslint-disable-next-line sonarjs/no-duplicate-string
        link: '/service/development',
        linkName: 'Digital-интегратор',
    },
    {
        // eslint-disable-next-line sonarjs/no-duplicate-string
        link: '/service/marketing',
        linkName: 'Интернет-маркетинг',
    },
    {
        // eslint-disable-next-line sonarjs/no-duplicate-string
        link: '/service/outstaff',
        linkName: 'Аутстаф',
    },
];

export const linkBot = [
    {
        link: '/company',
        linkName: 'О компании',
        isBlank: false,
    },
    {
        link: '/service/development',
        linkName: 'Разработка',
        isBlank: false,
    },
    {
        link: 'https://webpractik.marketing/',
        linkName: 'Маркетинг',
        isBlank: true,
    },
    {
        link: 'http://webpractik.ai/',
        linkName: 'ИИ-интегратор',
        isBlank: true,
    },
    {
        link: '/cases',
        linkName: 'Кейсы',
        isBlank: false,
    },
    {
        link: '/contacts',
        linkName: 'Контакты',
        isBlank: false,
    },
    {
        link: 'https://team.webpractik.ru/',
        linkName: 'Команда',
        isBlank: true,
    },
];

type HeaderMenuSubLink = {
    link: string;
    linkName: string;
    isBlank: boolean;
};

type HeaderMenuLink = {
    link: string;
    linkName: string;
    mainLink?: string;
    isBig?: boolean;
    isBlank?: boolean;
    isStatic?: boolean;
    linkDownList?: HeaderMenuSubLink[];
};

export const link: HeaderMenuLink[] = [
    {
        link: '',
        linkName: 'О компании',
        isStatic: true,
        linkDownList: [
            {
                link: '/company',
                linkName: 'Об агентстве',
                isBlank: false,
            },
            {
                link: 'https://team.webpractik.ru/',
                isBlank: true,
                linkName: 'Команда',
            },
        ],
    },
    {
        link: '/service/development',
        linkName: 'Разработка',
        isBlank: false,
    },
    {
        link: 'https://webpractik.marketing/',
        linkName: 'Маркетинг',
        isBlank: true,
    },
    {
        link: 'http://webpractik.ai/',
        linkName: 'ИИ-интегратор',
        isBlank: true,
    },
    {
        link: '/cases',
        linkName: 'Кейсы',
    },
    {
        link: '/contacts',
        linkName: 'Контакты',
    },
];
